module.exports = __webpack_public_path__ + "static/relax-health-cupping-therapy-woman-spa-ef6bff600f2a1e3862b646c3dfc734a7.webp";